import { useParams } from 'react-router-dom';
import { DefaultError } from '@tanstack/query-core';
import { UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { fetchEngageMessageById } from 'api/engage';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';
import { EngageMessage } from 'types/domain';

interface Options
    extends Omit<
        UseSuspenseQueryOptions<EngageMessage, DefaultError, EngageMessage, any>,
        'queryKey'
    > {}

const useCurrentLetter = (options: Options = {} as Options) => {
    const { accountId } = useCurrentAccount();
    const params = useParams<{ letter_id: string }>();
    const messageId = parseInt(params.letter_id);
    const { retry = false, ...restOptions } = options;

    return useSuspenseQuery({
        queryKey: accountQueryKeys.engageMessageById(accountId, messageId),
        queryFn: () => fetchEngageMessageById(accountId, messageId),
        retry,
        ...restOptions,
    });
};

export { useCurrentLetter };
